export default __webpack_public_path__ + "static/media/wd.b32e2b03.svg";